import {
  QueryParametersSerializer,
  SerializableParameters,
} from "../../shared/utils/serialize-query-parameters"

export interface ImageProcessorParams {
  width?: string | number
  height?: string | number
  autorotate?: boolean
  bgcolor?: string
  format?:
    | "jpg"
    | "jpeg"
    | "bmp"
    | "gif"
    | "png"
    | "png8"
    | "tif"
    | "tiff"
    | "webp"
  quality?: string | number
  center?: string
  mode?: "crop" | "pad" | "padBox"
  // needs processing
  blur?: {
    blur: number
    sigma: number
    threshold: number
  }
  hue?: {
    hue: number
    rotate: boolean
  }
}

export const imageProcessorParamsSerializer: QueryParametersSerializer<
  ImageProcessorParams
> = params => {
  const _params: SerializableParameters = {}

  const { blur, hue, ...doesNotNeedProcessing } = params

  Object.entries(doesNotNeedProcessing).forEach(([key, value]) => {
    _params[key] = value.toString()
  })

  if (blur) {
    Object.entries(blur).forEach(([key, value]) => {
      _params[key] = value.toString()
    })
  }

  if (hue) {
    _params.hue = hue.hue.toString()
    if (hue.hasOwnProperty("rotate")) {
      _params["hue.rotate"] = Boolean(hue.rotate).toString()
    }
  }

  return new URLSearchParams(_params).toString()
}
